"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../index");
const react_1 = __importStar(require("react"));
const icons_1 = require("../../icons");
const MoreMenu = ({ iconButtonProps, children, horizontal, }) => {
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(index_1.IconButton, { ...iconButtonProps, "data-testid": "more-menu", onClick: (e) => {
                setAnchorEl(e.currentTarget);
            } }, horizontal ? react_1.default.createElement(icons_1.HorizontalDots, null) : react_1.default.createElement(icons_1.VerticalDots, null)),
        react_1.default.createElement(index_1.Menu, { anchorEl: anchorEl, open: Boolean(anchorEl), onClose: () => setAnchorEl(null), onClick: () => setAnchorEl(null) }, children)));
};
exports.default = MoreMenu;
